import { format, parseISO, formatDistance, isValid } from 'date-fns';
import { zhCN } from 'date-fns/locale';

/**
 * 格式化日期为指定格式
 * @param {string|Date} date - 日期字符串或Date对象
 * @param {string} formatStr - 格式化字符串，默认为 'yyyy-MM-dd HH:mm:ss'
 * @returns {string} 格式化后的日期字符串
 */
export function formatDate(date, formatStr = 'yyyy-MM-dd HH:mm:ss') {
  if (!date) return '-';
  
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    if (!isValid(dateObj)) return '-';
    
    return format(dateObj, formatStr, { locale: zhCN });
  } catch (error) {
    console.error('日期格式化错误:', error);
    return '-';
  }
}

/**
 * 格式化为相对时间（如"3天前"）
 * @param {string|Date} date - 日期字符串或Date对象
 * @returns {string} 相对时间字符串
 */
export function formatRelativeTime(date) {
  if (!date) return '-';
  
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    if (!isValid(dateObj)) return '-';
    
    return formatDistance(dateObj, new Date(), { 
      addSuffix: true,
      locale: zhCN
    });
  } catch (error) {
    console.error('相对时间格式化错误:', error);
    return '-';
  }
}

/**
 * 格式化为日期时间（yyyy-MM-dd HH:mm:ss）
 * @param {string|Date} date - 日期字符串或Date对象
 * @returns {string} 格式化后的日期时间字符串
 */
export function formatDateTime(date) {
  return formatDate(date, 'yyyy-MM-dd HH:mm:ss');
}

/**
 * 格式化为仅日期（yyyy-MM-dd）
 * @param {string|Date} date - 日期字符串或Date对象
 * @returns {string} 格式化后的日期字符串
 */
export function formatDateOnly(date) {
  return formatDate(date, 'yyyy-MM-dd');
}

/**
 * 格式化为仅时间（HH:mm:ss）
 * @param {string|Date} date - 日期字符串或Date对象
 * @returns {string} 格式化后的时间字符串
 */
export function formatTimeOnly(date) {
  return formatDate(date, 'HH:mm:ss');
}

/**
 * 格式化Unix时间戳（秒级）
 * @param {number} timestamp - Unix时间戳（秒级）
 * @param {string} formatStr - 格式化字符串，默认为 'yyyy-MM-dd HH:mm:ss'
 * @returns {string} 格式化后的日期时间字符串
 */
export function formatUnixTime(timestamp, formatStr = 'yyyy-MM-dd HH:mm:ss') {
  if (!timestamp) return '-';
  
  try {
    // Unix时间戳通常是秒级，需要转换为毫秒级
    const date = new Date(timestamp * 1000);
    if (!isValid(date)) return '-';
    
    return formatDate(date, formatStr);
  } catch (error) {
    console.error('Unix时间戳格式化错误:', error);
    return '-';
  }
} 